<template>
  <path
    d="M16 11.0002V5.00024H20C21.1 5.00024 22 5.90024 22 7.00024V11.0002H16ZM20 19.0002C21.1 19.0002 22 18.1002 22 17.0002V13.0002H16V19.0002H20ZM14 5.00024V19.0002H4C2.9 19.0002 2 18.1002 2 17.0002V7.00024C2 5.90024 2.9 5.00024 4 5.00024H14ZM9.5 12.0002C9.5 11.1702 8.83 10.5002 8 10.5002C7.17 10.5002 6.5 11.1702 6.5 12.0002C6.5 12.8302 7.17 13.5002 8 13.5002C8.83 13.5002 9.5 12.8302 9.5 12.0002Z"
  />
</template>
